import { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'clsx';
import noop from 'lodash/noop';

import HeartFullIcon from '../../../shared/svgIcons/player/HeartFullIcon';
import HeartEmptyIcon from '../../../shared/svgIcons/player/HeartEmptyIcon';
import HeartBrokenIcon from '../../../shared/svgIcons/player/HeartBrokenIcon';
import FavoriteStyleContext from './context/FavoriteStyleContext';

import css from './favorite-icon.module.scss';

export default function FavoriteIcon({ isFollowing, isHovering, onClick }) {
  const { iconClassName, unFavoritedClassName } =
    useContext(FavoriteStyleContext);
  const fullClassName = classNames(css.favoriteHeart, iconClassName);
  const emptyClassName = classNames(
    css.favoriteHeart,
    iconClassName,
    unFavoritedClassName,
  );
  let icon;

  if (isFollowing) {
    icon = isHovering ? (
      <HeartBrokenIcon
        dataTestId="playerFavoriteIconDidFavorite"
        className={fullClassName}
      />
    ) : (
      <HeartFullIcon
        dataTestId="playerFavoriteIconDidFavorite"
        className={fullClassName}
      />
    );
  } else {
    icon = isHovering ? (
      <HeartFullIcon
        dataTestId="playerFavoriteIconNotFavorite"
        className={fullClassName}
      />
    ) : (
      <HeartEmptyIcon
        dataTestId="playerFavoriteIconNotFavorite"
        className={emptyClassName}
      />
    );
  }

  return (
    <div
      className={css.container}
      data-testid="favorite-icon-container"
      onClick={onClick}
    >
      {icon}
    </div>
  );
}

FavoriteIcon.propTypes = {
  onClick: PropTypes.func.isRequired,

  // inherited from FavoriteIconControl
  isHovering: PropTypes.bool.isRequired,
  isFollowing: PropTypes.bool.isRequired,
};

FavoriteIcon.defaultProps = {
  onClick: noop,
};
